// GroundwaterDialog.js
import { useState, useEffect } from "react"
import { Typography, Button } from '@mui/material'
import GroundwaterForm from './GroundwaterForm'
import "../../css/DemoCode.css"

/**
 * Groundwater Form is a group of data inputs usually shown when clicking on Subcatchment->Groundwater. 
 * This form is contained within GroundwaterDialog.
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {string} targetType The name of the SWMM inp section targetted by this form.
 * @param {string} target The name of the node targetted by this form.
 * @param {function} setOpenGWF Function to set flag for opening a GWF dialog.
 * @returns UI for interactive swmm modeling.
 */
export default function GroundwaterDialog({ model, setModel, targetType, target, setOpenGWF }) {
  const [submodel, setSubmodel] = useState()
  
  // Create a submodel for this editor interface.
  useEffect(()=>{
    let GROUNDWATER = {}

    if(model.GROUNDWATER && model.GROUNDWATER[target]){
      GROUNDWATER = {
        [target]: {
          ...model.GROUNDWATER[target]
        }
      }
    } else {
      GROUNDWATER = {
        [target]:{
          "Aquifer": "*",
          "Node": "*",
          "Esurf": 0,
          "A1": 0,
          "B1": 0,
          "A2": 0,
          "B2": 0,
          "A3": 0,
          "Dsw": 0,
          "Egwt": "*",
          "Ebot": null,
          "Egw": null,
          "Umc": null
      }}
    }

    setSubmodel({
      GROUNDWATER: GROUNDWATER
    })
  }, [])

  const saveEdits = () => {
    let cleanSub = JSON.parse(JSON.stringify(submodel))
    setModel(prev => ({
      ...prev,
      GROUNDWATER:{
        ...prev.GROUNDWATER, 
        [target]: {
          ...cleanSub.GROUNDWATER[target]
        }
      }
    }))
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  if(submodel){
    return(
      <>
      {
        <>
          <Typography id="modal-modal-title" variant="p4" >
            <div style={{display:"flex", flexDirection: "column", padding: '10px'}}>
              <label>Groundwater for Subcatchment {target}</label>
            </div>
          </Typography>
          <div>
            <Button fullWidth onClick={saveEdits} >Save Edits</Button>
          </div>
          <div style={{height: "280px", background:'black', overflowY: 'scroll', paddingBottom:"120px"}}>
            {
              targetType && 
              targetType in model && 
              target &&
              <GroundwaterForm model={submodel} setModel={setSubmodel} fullModel={model} target={target} setOpenGWF={setOpenGWF}/>
            }
          </div>
          </>
        }
      </>
    )
  } else {
    return ( 
    <>
    </>)
  }
}